import { SettingsPermissions } from "@redotech/account-common/permissions";
import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { ClientUploader } from "@redotech/redo-merchant-app-common/client/upload";
import { SendMessageState } from "@redotech/redo-return-ui/flows/chat-flow/send-message";
import { containsImg } from "@redotech/redo-return-ui/flows/chat-flow/step-rich-text-util";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { LabeledInput } from "@redotech/redo-web/labeled-input";
import Quill from "quill";
import { memo, useRef } from "react";
import { StepRichTextEditor } from "./step-rich-text";

export const SendMessageDetails = memo(function SendMessageDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<SendMessageState>) {
  const { t } = useTranslation();
  // TODO: Not sure what the right permission mix is
  const canEditSupportSettings = useHasPermission(
    SettingsPermissions.SET_SUPPORT_SETTINGS,
  );
  const canEditReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );
  const canEditSettings = canEditSupportSettings || canEditReturnsSettings;

  const quillRef = useRef<Quill | undefined>(undefined);

  const handleMessage = useHandler(() => {
    if (!quillRef.current) {
      return;
    }
    let message = quillRef.current.getText();
    let messageHtml: string | undefined = quillRef.current.getSemanticHTML();
    if (message === "\n") {
      message = "";
    }
    if (messageHtml === "<p></p>") {
      messageHtml = undefined;
    }

    if (messageHtml !== state.messageHtml || message !== state.message) {
      setState((state) => ({ ...state, message, messageHtml }));
    }
  });

  return (
    <ClientUploader>
      <LabeledInput
        errors={
          containsImg(state.messageHtml) ? [t("Cannot contain images")] : []
        }
        label={t("Message to customer")}
      >
        <StepRichTextEditor
          htmlValue={state.messageHtml}
          onTextChange={handleMessage}
          quillRef={quillRef}
          readOnly={!canEditSettings}
          textValue={state.message}
        />
      </LabeledInput>
      <LabeledInput
        errors={!state.next ? [t("Required")] : []}
        label={t("Next")}
      >
        {stepSelect({
          value: state.next,
          valueChange: (next) => setState({ ...state, next }),
        })}
      </LabeledInput>
    </ClientUploader>
  );
});
